<div class="app-container app-theme-white body-tabs-shadow fixed-header fixed-sidebar">
    <app-header></app-header>
    <div class="app-main">
        <!-- Menu Section --->
        <app-menus></app-menus>
        <!-- Menu section End -->
        <div class="app-main__outer">
            <div class="app-main__inner">
                <div class="app-page-title">
                    <div class="page-title-wrapper">
                        <div class="page-title-heading">
                            <div class="page-title-icon">
                                <i class="pe-7s-folder icon-gradient bg-mean-fruit"></i>
                            </div>
                            <div>Project Manuals <div class="page-title-subheading"> SO No. (Project Name): {{ProjectManualsName}}</div>
                                <nav class="" aria-label="breadcrumb">
                                    <ol class="breadcrumb">
                                        <li class="breadcrumb-item" *ngIf="showLi">
                                            <i class="fa fa-chevron-left pointer" aria-hidden="true"
                                                (click)="loadComponentData(2)"></i>&nbsp;&nbsp;&nbsp;
                                        </li>
                                        <span *ngFor="let folderArray of folderArray;let i=index">
                                            <li class="breadcrumb-item" (click)="openFolderOnHeader(folderArray)">
                                                <span *ngIf="i !== 0">&nbsp;/&nbsp;</span>
                                                <!-- {{ i }} -->
                                                <a href="javascript:void(0);">{{ folderArray.folder_name }}</a>
                                            </li>

                                        </span>

                                        <!-- <li class="breadcrumb-item"><a href="javascript:void(0);">Library</a></li>
                                        <li class="active breadcrumb-item" aria-current="page">Data</li> -->
                                    </ol>
                                </nav>
                            </div>
                        </div>

                    </div>
                </div>

                <div *ngIf="manualListData" class="col-md-12">
                    <div class="main-card mb-3 card">
                        <div class="card-body">
                            <div class="col-12">
                                <div class="card-box">
                                    <div class="row">
                                        <div class="col-md-3" *ngFor="let file_element of manualList">
                                            <div class="file-man-box" *ngIf="file_element.type === 'folder'"
                                                (click)="openSubFolder(file_element)">
                                                <!-- <div class="file-close fa fa-download pointer"
                                                    (click)="downloadDocument(content, file_element)"></div> -->
                                                <div class="file-img-box"><img src="assets/images/icon/folder.png"
                                                        alt="icon"></div>
                                                <div class="file-man-title">
                                                    <h5 class="mb-0 text-overflow">{{ file_element.document_name }}</h5>
                                                </div>
                                            </div>
                                            <div class="file-man-box" *ngIf="file_element.type === 'file'">
                                                <!-- <div class="file-close fa fa-download pointer"
                                                    (click)="downloadDocument(content, file_element)"></div> -->
                                                <div class="file-img-box pointer"
                                                    (click)="openDocument(content, file_element)">
                                                    <img [src]="getImagePath(file_element.document_name)" alt="icon"
                                                        (error)="handleImageError($event)">
                                                </div>
                                                <div class="file-man-title">
                                                    <h5 class="mb-0 text-overflow">{{ file_element.document_name }}</h5>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="!manualListData" class="row">
                    <div class="col-md-12">
                        <div class="main-card mb-3 card">
                            <div class="card-body text-center">
                                <div>Soft Manual For The Selected Project Not Yet Published!</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="app-drawer-overlay d-none animated fadeIn"></div>
</div>
<ng-template #content let-modal>
    <div class="modal-content">
        <img *ngIf="imageurl" [src]="imageurl" />
        <div *ngIf="otherurl"
            style="background-color:whiteSmoke; height: 36px; position: absolute; left:990px; width: 33px;"> </div>
        <iframe *ngIf="otherurl" id="iframe" [src]="otherurl" scrolling="true" onload="injectJS()"
            oncontextmenu="return false;" style="width:800px;height:500px;pointer-events: scroll;"></iframe>
        <audio *ngIf="audiourl" id="mp3audio" controls controlsList="nodownload">
            <source [src]="audiourl" type="audio/mpeg">
        </audio>
        <video id="movtest" *ngIf="videourl" autoplay="autoplay" controls disablePictureInPicture
            controlsList="nodownload">
            <source [src]="videourl" type='video/mp4; [codecs]="codecs"'>
        </video>
    </div>
</ng-template>